import React from 'react'
import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material/'

const PREFIX = 'CatalogCategoryText'

const classes = {
  title: `${PREFIX}-title`,
  length: `${PREFIX}-length`,
}

const StyledTypography = styled(Typography)(({ theme }) => ({
  [`&.${classes.title}`]: {
    color: 'black',
    fontWeight: 'bold',
    overflowWrap: 'break-word',

    '&:hover': {
      textDecoration: 'underline',
    },
  },

  [`& .${classes.length}`]: {
    fontWeight: 'bold',
    paddingLeft: theme.spacing(0.2),

    '&:hover': {
      textDecoration: 'underline',
    },
  },
}))

type Props = {
  name: string | null | undefined
  length: number | null | undefined
}

export const CatalogCategoryText = (props: Props) => (
  <StyledTypography className={classes.title}>
    {props.name}
    <Typography className={classes.length} color="textSecondary" display="inline">
      {`(${props.length})`}
    </Typography>
  </StyledTypography>
)
